import { createSlice } from '@reduxjs/toolkit';
import { ICompanySettings } from '../../shared/interfaces/settings/ISettings';

const initialState: ICompanySettings = {
  thumbnail: '',
  faviconPath: '',
  invertedThumbnail: '',
  primaryColor: localStorage.getItem('primaryColor') ?? '#7152F3',
  id: 0,
  title: 'OneHR',
  path: '',
  mime: '',
  originalName: '',
  createdAt: '',
  updatedAt: '',
};
const companySettingsSlice = createSlice({
  name: 'companySettings',
  initialState,
  reducers: {
    setCompanySettings: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default companySettingsSlice;
